import { SVGProps } from 'react';

const EyeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width || '18'}
      height={props?.height || '18'}
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clipPath="url(#clip0_7292_12347)">
        <path
          d="M8.99995 3.74805C4.2697 3.74805 1.9747 8.0103 1.56745 8.85405C1.54569 8.89893 1.53438 8.94816 1.53438 8.99805C1.53438 9.04793 1.54569 9.09716 1.56745 9.14205C1.97395 9.9858 4.26895 14.248 8.99995 14.248C13.731 14.248 16.0252 9.9858 16.4325 9.14205C16.4542 9.09716 16.4655 9.04793 16.4655 8.99805C16.4655 8.94816 16.4542 8.89893 16.4325 8.85405C16.026 8.0103 13.731 3.74805 8.99995 3.74805Z"
          stroke={props?.fill || '#616161'}
          strokeWidth="1.28571"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.00002 11.2461C10.2427 11.2461 11.25 10.2387 11.25 8.99609C11.25 7.75345 10.2427 6.74609 9.00002 6.74609C7.75737 6.74609 6.75002 7.75345 6.75002 8.99609C6.75002 10.2387 7.75737 11.2461 9.00002 11.2461Z"
          stroke={props?.fill || '#616161'}
          strokeWidth="1.28571"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7292_12347">
          <rect width={props?.width || '18'} height={props?.height || '18'} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EyeIcon;
